import { IDEAL_ASPECT_RATIO } from './cropper-const';

export const withInitialCropData = (imageMetaData) => {
  const {
    Width,
    Height,
  } = imageMetaData;

  return {
    ...imageMetaData,
    CropSettings: {
      cropX: 0,
      cropY: 0,
      cropWidth: Width,
      cropHeight: Math.min(Height, IDEAL_ASPECT_RATIO * Width),
    },
  };
};
